export const TIER_POSITIONS = {
  STANDALONE: 'standalone',
  STANDALONE_LEFT: 'standalone-left',
  STANDALONE_BOTTOM: 'standalone-bottom',
  STANDALONE_BOTTOM_SEO: 'standalone-bottom-seo',
  CAMPAIGN: 'campaign',
  CAMPAIGN_BOTTOM: 'campaign-bottom',
  GRID: 'grid',
};
